export const getApiUrl = () =>
  process.env.REACT_APP_ROOT_API || "https://dev.his.evernetwork.io/v1/api";
